import usePosOrderPayment from "../atoms/usePosOrderPaymentAtom";
import usePosOrderUser from "../atoms/usePosOrderUser";
import { useSetPriorityModal } from "../atoms/usePriorityModal";
import usePosSessionPay from "../mutations/pos/usePosSessionPay";
import { PaymentMethodEnum } from "../utils/enum";
import usePosOrderHook from "./usePosOrderHook";
import {
  useSessionId,
  useSessionTotalAmount,
} from "./usePosOrderTableSessionHook";
import usePosOrderTipHook from "./usePosOrderTipHook";
import { PaymentMethodIdType } from "../utils/interfaces";
import { useSetModal } from "../atoms/useModal";

const usePaySessionHook = (customPaymentId?: PaymentMethodIdType) => {
  const setPriorityModal = useSetPriorityModal();
  const setModal = useSetModal();
  const [paymentId] = usePosOrderPayment();
  const [orderUser] = usePosOrderUser();
  const sessionId = useSessionId();
  const { mutateAsync: paySession } = usePosSessionPay();
  const { resetPosOrderStates } = usePosOrderHook();
  const { tipValue } = usePosOrderTipHook();
  const sessionTotalAmount = useSessionTotalAmount();
  const paymentMethod = customPaymentId ?? paymentId;

  return (customerPaymentAmount?: string) => {
    return paySession({
      session_id: sessionId,
      payment_method: paymentMethod,
      email: orderUser?.email,
      phone: orderUser?.telephone,
      name: orderUser?.name,
      tip: `${tipValue}`,
    }).then(() => {
      if (
        paymentMethod === PaymentMethodEnum.POS_TERMINAL ||
        paymentMethod === PaymentMethodEnum.IDEAL ||
        paymentMethod === PaymentMethodEnum.CREDIT_CARD
      ) {
        setPriorityModal("pendingPayment", {
          eventName: `sessionPosPaymentSuccess-${sessionId}`,
          sessionId: sessionId,
          callback: () => {
            resetPosOrderStates(undefined, false, true, {
              sessionId,
              sessionTotalAmount: sessionTotalAmount,
              sessionPaymentId: paymentMethod,
            });
          },
        });
      } else if (paymentMethod === PaymentMethodEnum.SPLIT_PAYMENT) {
        setModal("splitPayment", {
          totalAmount: sessionTotalAmount,
          orderId: sessionId,
          isSession: true,
        });
      } else {
        resetPosOrderStates(
          undefined,
          true,
          false,
          {
            sessionId,
            sessionTotalAmount: sessionTotalAmount,
            sessionPaymentId: paymentMethod,
          },
          customerPaymentAmount
        );
      }
    });
  };
};

export default usePaySessionHook;
